/* eslint-disable no-debugger */
import { SETCOUNT } from "../constant";

export const setCount = (total) => ({ type: SETCOUNT, data: total });
